import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Fade } from '@material-ui/core';
import { ErrorOutline } from '@material-ui/icons';
import { Snackbar } from '../../common/components';

const S = {
  Message: styled.p`
    display: flex;
    align-items: center;
  `,
  ErrorOutline: styled(ErrorOutline)`
    margin-right: 0.5rem;
  `,
};

const ErrorSnackbar = ({ error, children }) => (error
  ? (
    <Snackbar
      open={error}
      TransitionComponent={Fade}
      ContentProps={{
        'aria-describedby': 'error-message',
      }}
      message={(
        <S.Message id="error-message">
          <S.ErrorOutline />
          오류가 발생했습니다. 잠시 후 다시 실행해주세요. 문제가 지속되면 고객센터에 연락해주세요.
        </S.Message>
      )}
      error
    />
  )
  : children);

ErrorSnackbar.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
};

ErrorSnackbar.defaultProps = {
  error: false,
  children: '',
};

export default ErrorSnackbar;
